export default "__VITE_ASSET__Rxcs4oBl__"